<template>
	<div
		class="product-details-header"
		:class="{ 'has-no-gallery': !hasGallery }"
		@click="handleClick"
	>
		<template v-if="hasGallery">
			<img
				v-if="productDetails.gallery.length === 1"
				class="product-details-image"
				alt="product image"
				:src="productDetails.gallery[0].full"
			/>
			<swiper v-else class="swiper" :options="defaultSwiperOptions">
				<swiper-slide
					v-for="(image, index) in productDetails.gallery"
					:class="{ 'has-image': image.full }"
					:key="index"
				>
					<img class="product-details-image" alt="" :src="image.full" />
				</swiper-slide>
			</swiper>
		</template>
		<div v-else class="placeholder-image-wrapper" />
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
	name: 'ProductDetailsHeader',

	components: {
		Swiper,
		SwiperSlide
	},

	props: {
		productDetails: {
			type: Object,
			default: () => {}
		}
	},

	computed: {
		hasGallery() {
			return !!this.productDetails.gallery.length
		},

		defaultSwiperOptions() {
			return {
				navigation: false,
				pagination: {
					el: '.product-details-swiper-pagination',
					clickable: true,
					dynamicBullets: this.productDetails.gallery.length > 4,
					dynamicMainBullets: 1
				}
			}
		}
	},

	methods: {
		handleClick() {
			this.$emit('click')
		}
	}
}
</script>
